import React, { useCallback, useEffect, useState } from "react"
import { AddOfferHelperText, ChangeLanguageComponent } from "components/shared/ModalHelpers"
import useProfile from "hooks/useProfile"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { LocalStorageService } from "services/api-service"
import { logout } from "store/auth"
import { Row } from "ui/components/atoms/_atoms"
import Button from "ui/components/atoms/button"
import Modal from "ui/components/molecules/modal"
import PricingSection from "ui/components/sections/pricing-section"
import { PLANS_ARRAY } from "ui/data"

const AddOfferPlan = ({ state, onChange, setType }: any) => {
  const { t, i18n } = useTranslation(["add-offer", "common"])
  const dispatch = useDispatch()
  const profile = useProfile()

  const [code, setCode] = useState<string>("")
  const [params, setParams] = useState<{
    code?: string
    type?: string
    period: string
    plan: string
  }>({
    period: "1",
    type: "offer",
    plan: PLANS_ARRAY["offer"][0].slug,
  })

  const onSubmit = useCallback(async () => {
    onChange(params.plan, params.type, params.period, params.code)
  }, [onChange, params.plan, params.type, params.period, params.code])

  const handleLogOut = useCallback(() => {
    LocalStorageService.removeObject("token")
    dispatch(logout())
  }, [dispatch])

  const handleChangeParams = useCallback(
    ({ code, type, period, plan }: any) => {
      setParams({
        code,
        type,
        period,
        plan,
      })
      setType(type)
    },
    [setType],
  )

  useEffect(() => {
    const fetchCode = async () => {
      const discount = await LocalStorageService.getObject("code")
      if (discount) {
        setCode(discount)
        LocalStorageService.removeObject("code")
      }
    }

    fetchCode()
  }, [])
  return (
    <Modal
      show={true}
      icon="plus-circle"
      title={t("title", { ns: "add-offer" })}
      text={t("text", { ns: "add-offer" })}
      $maxWidth="1300px"
      showBackground={false}
      mobileFullScreen={true}
      helperElement={
        <ChangeLanguageComponent>
          <AddOfferHelperText />
        </ChangeLanguageComponent>
      }
      helperButton={{
        text: t("logout", { ns: "common" }),
        onClick: handleLogOut,
      }}
      bottomElement={
        <Row $justifyContent="flex-end">
          <Button onClick={onSubmit}>{t("next", { ns: "common" })}</Button>
        </Row>
      }
    >
      <PricingSection
        initialCode={code}
        initialPlan={state?.plan}
        initialPeriod={state?.period}
        setParams={handleChangeParams}
        currency={i18n.language === "pl" ? "pl" : "eur"}
        translator={e => t(`basket.${e}`, { ns: "add-offer" })}
        showTest={profile?.status === "add_offer"}
      />
    </Modal>
  )
}

export default AddOfferPlan
